import React, { createContext, useState, useContext, useEffect } from 'react';

export interface Message {
    text: string,
    type: string // "error", "notification"
}

interface NotificationContextProps {
    messages: Message[];
    pushMessage: (message: Message) => void;
}

export const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

interface NotificationProviderProps {
    children: React.ReactNode;
}

export const useNotifications = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('NotificationContext must be used within an AuthProvider');
    }
    return context;
};

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
    const [messages, setMessages] = useState<Message[]>([]);

    const pushMessage = (message: Message) => {
        setMessages(prevMessages => [...prevMessages, message])
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (messages.length > 0) {
                setMessages(prevMessages => prevMessages.slice(1))
            }
        }, 5000); 
    }, [messages]);

    return (
        <NotificationContext.Provider value={{ messages, pushMessage }}>
            {children}
        </NotificationContext.Provider>
    );
};